var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRotate = function SvgRotate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1207_1915)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1207_1915",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 20,
    height: 20,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3,
    y: 2,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85462 9.21697H5L7.67211 12.7798L10.3442 9.21697H8.87675C9.29815 6.82071 11.39 5 13.907 5C16.7279 5 19.0147 7.28678 19.0147 10.1077C19.0147 12.9286 16.7279 15.2154 13.907 15.2154L13.907 13.6705L10.3442 16.3426L13.907 19.0147L13.907 17.2154C17.8325 17.2154 21.0147 14.0331 21.0147 10.1077C21.0147 6.18222 17.8325 3 13.907 3C10.2832 3 7.29283 5.71192 6.85462 9.21697Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85462 9.21697H5L7.67211 12.7798L10.3442 9.21697H8.87675C9.29815 6.82071 11.39 5 13.907 5C16.7279 5 19.0147 7.28678 19.0147 10.1077C19.0147 12.9286 16.7279 15.2154 13.907 15.2154L13.907 13.6705L10.3442 16.3426L13.907 19.0147L13.907 17.2154C17.8325 17.2154 21.0147 14.0331 21.0147 10.1077C21.0147 6.18222 17.8325 3 13.907 3C10.2832 3 7.29283 5.71192 6.85462 9.21697Z",
    fill: "#191C1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85462 9.21697V10.217H7.73739L7.8469 9.34103L6.85462 9.21697ZM5 9.21697V8.21697H3L4.2 9.81697L5 9.21697ZM7.67211 12.7798L6.87211 13.3798L7.67211 14.4464L8.47211 13.3798L7.67211 12.7798ZM10.3442 9.21697L11.1442 9.81697L12.3442 8.21697H10.3442V9.21697ZM8.87675 9.21697L7.89186 9.04377L7.68554 10.217H8.87675V9.21697ZM13.907 15.2154L12.907 15.2154L12.907 16.2154H13.907V15.2154ZM13.907 13.6705L14.907 13.6705L14.907 11.6705L13.307 12.8705L13.907 13.6705ZM10.3442 16.3426L9.74422 15.5426L8.67755 16.3426L9.74422 17.1426L10.3442 16.3426ZM13.907 19.0147L13.307 19.8147L14.907 21.0147L14.907 19.0147H13.907ZM13.907 17.2154V16.2154H12.907L12.907 17.2154L13.907 17.2154ZM6.85462 8.21697H5V10.217H6.85462V8.21697ZM4.2 9.81697L6.87211 13.3798L8.47211 12.1798L5.8 8.61697L4.2 9.81697ZM8.47211 13.3798L11.1442 9.81697L9.54422 8.61697L6.87211 12.1798L8.47211 13.3798ZM10.3442 8.21697H8.87675V10.217H10.3442V8.21697ZM9.86163 9.39017C10.2004 7.46375 11.8838 6 13.907 6V4C10.8961 4 8.39589 6.17767 7.89186 9.04377L9.86163 9.39017ZM13.907 6C16.1756 6 18.0147 7.83907 18.0147 10.1077H20.0147C20.0147 6.7345 17.2802 4 13.907 4V6ZM18.0147 10.1077C18.0147 12.3763 16.1756 14.2154 13.907 14.2154V16.2154C17.2802 16.2154 20.0147 13.4809 20.0147 10.1077H18.0147ZM14.907 15.2154L14.907 13.6705L12.907 13.6705L12.907 15.2154L14.907 15.2154ZM13.307 12.8705L9.74422 15.5426L10.9442 17.1426L14.507 14.4705L13.307 12.8705ZM9.74422 17.1426L13.307 19.8147L14.507 18.2147L10.9442 15.5426L9.74422 17.1426ZM14.907 19.0147L14.907 17.2154L12.907 17.2154L12.907 19.0147H14.907ZM13.907 18.2154C18.3848 18.2154 22.0147 14.5854 22.0147 10.1077H20.0147C20.0147 13.4809 17.2802 16.2154 13.907 16.2154V18.2154ZM22.0147 10.1077C22.0147 5.62993 18.3848 2 13.907 2V4C17.2802 4 20.0147 6.7345 20.0147 10.1077H22.0147ZM13.907 2C9.77263 2 6.36233 5.09371 5.86235 9.09292L7.8469 9.34103C8.22332 6.33013 10.7938 4 13.907 4V2Z",
    fill: "white",
    mask: "url(#path-1-outside-1_1207_1915)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1207_1915",
    x: 0,
    y: 0,
    width: 25.0146,
    height: 25.0156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1207_1915"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1207_1915",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRotate);
export { ForwardRef as ReactComponent };